// Render Prop

import React, { Component, memo } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { EmployerApi } from "../../../util/api/EmployerApi";
import { Redirect } from 'react-router';

import { observer } from 'mobx-react';

import { FormGroup, Label, Input } from 'reactstrap';


import TableWidget from "../../widgets/TableWidget";


class SelectHoliday extends Component {
    static displayName = SelectHoliday.name;

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            selectedHoliday: false,
            filterText: ""
        };

        this.props.store.updateBanner("Update Date Notice");

        this.holidaySelect = this.holidaySelect.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.employerTable = this.employerTable.bind(this);
        this.handleSubmission = this.handleSubmission.bind(this);
    }

    handleSubmission(event) {
        const id = event.target.value;
        this.setState({ selectedHoliday: id })
    }


    render() {
        if (this.state.selectedHoliday == false) {
            return (
                <React.Fragment>
                    {this.holidaySelect()}
                    {this.employerTable()}
                </React.Fragment>
            )
        }
        else {
            return <Redirect push to={"/staff/Holiday/" + this.state.selectedHoliday} />
        }
    }

    async handleFilterChange(event) {
        await this.setState({ filterText: event.target.value });
    }

    holidaySelect() {
        const holidays = this.props.store.holidays.collection;

        console.log(holidays);

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    <Label for="holidaysFilter">Filter By Name</Label>
                    <Input placeHolder="Display Name..." type="text" id="holidaysFilter" value={this.state.filterText} onChange={this.handleFilterChange} />
                </div>
            </div>
        )
    }

    getTableColumns() {
        return (
            [
                {
                    Header: "", accessor: "col1",
                    Cell: (props) => (
                        <button className="btn btn-light" value={props.cell.value} onClick={this.handleSubmission}>
                            Edit
                        </button>
                    ),
                    props: {
                        colspan: "1", style: { width: "10%", borderBottom: "3px solid white"  }
                    }
                },
                { Header: "Display Name", accessor: "col2", props: { colspan: "1", style: {width: "25%"}} },
                { Header: "Holiday Begin", accessor: "col3", props: { colspan: "1", style: { width: "20%" }} },
                { Header: "Holiday End", accessor: "col4", props: { colspan: "1", style: { width: "25%" } } },
            ]
        );
    }

    getTableData(holidays) {
        return holidays.map(holiday => {
            return {
                    col1: holiday.id,
                    col2: holiday.holidayName,
                    col3: holiday.holidayBeginObject.clone().format("l"),
                    col4: (holiday.holidayEnd ? holiday.holidayEndObject.clone().format("l") : "N/A")
                }
            }
        )
    }

    employerTable() {
        const columns = this.getTableColumns();

        let holidays = this.props.store.holidays.collection;

        holidays = holidays.filter(holiday => {
            return holiday.holidayName.toLowerCase().includes(this.state.filterText.toLowerCase());
        })

        //Sort employers by name;
        /*employers.sort((employerA, employerB) => {
            const nameA = employerA.name.toLowerCase()
            const nameB = employerB.name.toLowerCase()

            if (nameA > nameB) {
                return 1
            }
            else if (nameA < nameB) {
                return -1
            }
            return 0
        });*/

        const data = this.getTableData(holidays);

        return (
            <TableWidget
                tableProps={{ style: "mt-4" }}
                headerGroupProps={{ }}
                rowProps={{  }}
                columns={columns}
                data={data} />
        )
    }

}



SelectHoliday = observer(SelectHoliday);


export { SelectHoliday}